(function () {
  var cartUpdateTimer = null;

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format || "{{amount}}TL");
    }

    var amount = (Number(cents || 0) / 100).toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return amount + "TL";
  }

  function getProductData(root) {
    if (root.rpProductData) return root.rpProductData;

    var script = document.querySelector("[data-product-variants-json]");
    if (!script) return null;

    try {
      root.rpProductData = JSON.parse(script.textContent);
    } catch (error) {
      root.rpProductData = null;
    }

    return root.rpProductData;
  }

  function getSelectedOptions(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.rp-product-form input[type="radio"]:checked')).map(function (input) {
      return input.value;
    });
  }

  function syncOptionInputs(root, variant) {
    if (!variant || !variant.options) return;

    root.querySelectorAll(".rp-product-form details").forEach(function (details, index) {
      var value = variant.options[index];
      if (!value) return;
      var input = Array.prototype.find.call(details.querySelectorAll('input[type="radio"]'), function (radio) {
        return radio.value === value;
      });
      if (input) input.checked = true;
    });
  }

  function getChangedOptionIndex(root, product, changedInput) {
    if (!product || !product.options || !changedInput) return -1;

    var optionName = changedInput.name.replace(/^options\[/, "").replace(/\]$/, "");
    var directIndex = product.options.indexOf(optionName);
    if (directIndex > -1) return directIndex;

    var optionGroups = Array.prototype.slice.call(root.querySelectorAll(".rp-product-form .rp-option"));
    var group = changedInput.closest(".rp-option");
    return optionGroups.indexOf(group);
  }

  function getVariantByOptions(product, selectedOptions, changedIndex, changedValue) {
    if (!product || !product.variants) return null;

    var exact = product.variants.find(function (variant) {
      return selectedOptions.every(function (value, index) {
        return variant.options && variant.options[index] === value;
      });
    });

    if (exact) return exact;

    if (changedIndex > -1 && changedValue) {
      return product.variants.find(function (variant) {
        return variant.available && variant.options && variant.options[changedIndex] === changedValue;
      }) || product.variants.find(function (variant) {
        return variant.options && variant.options[changedIndex] === changedValue;
      }) || null;
    }

    return null;
  }

  function activateProductMedia(root, mediaId, fallbackImage) {
    if (mediaId) {
      var thumb = root.querySelector('[data-product-thumb="' + mediaId + '"]');
      var frame = root.querySelector('[data-product-media="' + mediaId + '"]');

      if (thumb && frame) {
        root.querySelectorAll("[data-product-thumb]").forEach(function (item) {
          item.classList.remove("is-active");
        });
        root.querySelectorAll("[data-product-media]").forEach(function (item) {
          item.classList.remove("is-active");
          item.querySelectorAll("video").forEach(function (video) {
            video.pause();
          });
        });
        thumb.classList.add("is-active");
        frame.classList.add("is-active");
        return;
      }
    }

    if (fallbackImage && fallbackImage.src) {
      var activeImage = root.querySelector(".rp-product__frame.is-active img") || root.querySelector(".rp-product__frame img");
      if (activeImage) {
        activeImage.removeAttribute("srcset");
        activeImage.removeAttribute("sizes");
        activeImage.src = fallbackImage.src;
      }
    }
  }

  function updateProductVariant(root, changedInput) {
    var product = getProductData(root);
    var selectedOptions = getSelectedOptions(root);
    var changedIndex = getChangedOptionIndex(root, product, changedInput);
    var changedValue = changedInput && changedInput.value;
    var variant = getVariantByOptions(product, selectedOptions, changedIndex, changedValue);
    var form = root.querySelector(".rp-product-form");
    if (!variant || !form) return;

    syncOptionInputs(root, variant);

    var idInput = form.querySelector("[data-variant-id]");
    var price = root.querySelector("[data-product-price]");
    var compare = root.querySelector("[data-product-compare]");
    var button = root.querySelector("[data-add-to-cart]");
    var moneyFormat = root.dataset.moneyFormat;

    if (idInput) idInput.value = variant.id;
    if (price) price.textContent = formatMoney(variant.price, moneyFormat);

    if (compare) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.hidden = false;
        compare.textContent = formatMoney(variant.compare_at_price, moneyFormat);
      } else {
        compare.hidden = true;
        compare.textContent = "";
      }
    }

    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? "Sepete ekle" : "Tükendi";
    }

    var mediaId = variant.featured_media && variant.featured_media.id;
    activateProductMedia(root, mediaId, variant.featured_image);

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());
    }
  }

  document.addEventListener("change", function (event) {
    if (!event.target.matches('.rp-product-form input[type="radio"]')) return;
    var root = event.target.closest("[data-product-root]");
    if (root) updateProductVariant(root, event.target);
  });

  document.addEventListener("submit", function (event) {
    var quickForm = event.target.closest("[data-card-quick-add]");
    if (!quickForm || typeof fetch !== "function") return;

    event.preventDefault();
    var button = quickForm.querySelector("button");
    var originalText = button ? button.textContent : "";
    if (button) {
      button.disabled = true;
      button.textContent = "Ekleniyor";
    }

    fetch(quickForm.action, {
      method: "POST",
      body: new FormData(quickForm),
      headers: {
        "Accept": "application/json"
      }
    }).then(function (response) {
      if (!response.ok) throw new Error("cart add failed");
      return response.json();
    }).then(function () {
      if (button) button.textContent = "Sepete eklendi";
      return fetch("/cart.js", { headers: { "Accept": "application/json" } });
    }).then(function (response) {
      if (!response || !response.ok) return null;
      return response.json();
    }).then(function (cart) {
      if (cart && typeof cart.item_count !== "undefined") {
        document.querySelectorAll(".rp-cart-count").forEach(function (item) {
          item.textContent = cart.item_count;
        });
      }
    }).catch(function () {
      if (button) button.textContent = "Tekrar dene";
    }).finally(function () {
      if (!button) return;
      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText || "Sepete ekle";
      }, 1400);
    });
  });

  document.addEventListener("click", function (event) {
    var qty = event.target.closest("[data-qty]");
    if (qty) {
      var wrapper = qty.closest(".rp-quantity");
      var input = wrapper && wrapper.querySelector('input[type="number"]');
      var min = Number(qty.dataset.qtyMin || (input && input.min) || 1);
      if (input) {
        input.value = Math.max(min, Number(input.value || min) + Number(qty.dataset.qty));
        input.dispatchEvent(new Event("change", { bubbles: true }));
        if (input.name === "updates[]") {
          window.clearTimeout(cartUpdateTimer);
          cartUpdateTimer = window.setTimeout(function () {
            var form = input.closest("form");
            var updateButton = form && form.querySelector("[data-cart-update]");
            if (form && updateButton && typeof form.requestSubmit === "function") {
              form.requestSubmit(updateButton);
            } else if (form) {
              form.submit();
            }
          }, 450);
        }
      }
    }

    var more = event.target.closest("[data-option-more]");
    if (more) {
      var option = more.closest(".rp-option");
      var values = option && option.querySelector("[data-option-values]");
      if (!values) return;
      var expanded = values.classList.toggle("is-expanded");
      more.textContent = expanded ? "Daha az goster" : "Daha fazla goster";
    }

    var thumb = event.target.closest("[data-product-thumb]");
    if (thumb) {
      var root = thumb.closest("[data-product-root]");
      if (!root) return;

      root.querySelectorAll("[data-product-thumb]").forEach(function (item) {
        item.classList.remove("is-active");
      });
      root.querySelectorAll("[data-product-media]").forEach(function (item) {
        item.classList.remove("is-active");
        item.querySelectorAll("video").forEach(function (video) {
          video.pause();
        });
      });

      thumb.classList.add("is-active");
      var frame = root.querySelector('[data-product-media="' + thumb.dataset.productThumb + '"]');
      if (frame) frame.classList.add("is-active");
    }

    var swatch = event.target.closest("[data-card-swatch]");
    if (swatch) {
      event.preventDefault();
      var card = swatch.closest(".rp-product-card");
      if (!card) return;

      card.querySelectorAll("[data-card-swatch]").forEach(function (item) {
        item.classList.remove("is-active");
      });
      swatch.classList.add("is-active");

      var image = card.querySelector(".rp-product-card__media img");
      if (image && swatch.dataset.cardImage) {
        image.removeAttribute("srcset");
        image.removeAttribute("sizes");
        image.src = swatch.dataset.cardImage;
      }

      var price = card.querySelector(".rp-product-card__price b");
      var deal = card.querySelector(".rp-product-card__deal strong");
      if (swatch.dataset.cardPrice) {
        if (price) price.textContent = swatch.dataset.cardRegularPrice || swatch.dataset.cardPrice;
        if (deal) deal.textContent = swatch.dataset.cardPrice;
      }

      var variantInput = card.querySelector("[data-card-variant-input]");
      if (variantInput && swatch.dataset.cardVariantId) {
        variantInput.value = swatch.dataset.cardVariantId;
      }

      if (swatch.dataset.cardUrl) {
        var media = card.querySelector(".rp-product-card__media");
        var title = card.querySelector(".rp-product-card__meta a");
        var dealLink = card.querySelector(".rp-product-card__deal");
        if (media) media.href = swatch.dataset.cardUrl;
        if (title) title.href = swatch.dataset.cardUrl;
        if (dealLink) dealLink.href = swatch.dataset.cardUrl;
      }

      if (swatch.dataset.cardTitle) {
        var titleText = card.querySelector(".rp-product-card__meta strong");
        if (titleText) titleText.textContent = swatch.dataset.cardTitle;
        if (image) image.alt = swatch.dataset.cardTitle;
      }
    }
  });
})();
